export async function apiFetch(endpoint, { token, method = "GET", body } = {}) {
  const API_URL = process.env.REACT_APP_API_URL;

  const res = await fetch(`${API_URL}${endpoint}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    throw new Error("Session expirée");
  }

  if (!res.ok) throw new Error(`Erreur API (${res.status})`);
  try {
    return await res.json();
  } catch {
    return null;
  }
}
